import { adminLogin } from '../../../api'
import history from '../../../history'

function login (username, password) {
  return dispatch => {
    dispatch(request())

    adminLogin(username, password).fetchPromise
      .then(
        response => {
          dispatch(success({ username: username, tokens: response }))
          history.push('/admin')
        },
        error => {
          dispatch(failure(error.toString()))
        }
      )
  }

  function request () { return { type: 'ADMIN_LOGIN_REQUEST' } }

  function success (user) { return { type: 'ADMIN_LOGIN_SUCCESS', user } }

  function failure (error) { return { type: 'ADMIN_LOGIN_FAILURE', error } }
}

const logout = () => ({
  type: 'ADMIN_LOGOUT'
})

const setTokens = (accessToken, refreshToken) => ({
  type: 'ADMIN_SET_TOKENS',
  payload: {
    token: accessToken,
    refreshToken
  }
})
export const adminUserActions = {
  login,
  logout,
  setTokens
}
